var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          [
            _c("pulse-loader", {
              staticStyle: { "text-align": "center" },
              attrs: { loading: !_vm.records, color: _vm.color },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.records
          ? _c("table", { staticClass: "table table-hover" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _c("input", {
                      attrs: { type: "checkbox" },
                      on: { change: _vm.selectAll },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "sortingClass.name[filterSort]",
                      attrs: { name: "name" },
                    },
                    [_vm._v("Имя")]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("ЕГК")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Препараты")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      class: _vm.sortingClass.offers[_vm.filterSort],
                      attrs: { name: "offers" },
                      on: { click: _vm.changeSort },
                    },
                    [_vm._v("aptekamos")]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Link")]),
                  _vm._v(" "),
                  _vm.tableType == "grouped"
                    ? _c("th", [_vm._v("Search слова")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tableType == "grouped"
                    ? _c("th", [_vm._v("Запросы")])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.records, function (record, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _c("input", {
                        staticClass: "selectedDrug",
                        attrs: { type: "checkbox", name: record.id },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(record.ros_name))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      _vm._l(record.codes, function (code, index) {
                        return _c("p", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(code.egk_id) +
                              "\n                        "
                          ),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      _vm._l(record.codes, function (code, index) {
                        return _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.printCode(code.info.DRUG_NAME)
                            ),
                          },
                        })
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("td", [
                      record.parsed_info
                        ? _c("div", [
                            _c(
                              "div",
                              [
                                record.parsed_info.offers
                                  ? [
                                      _c("p", [
                                        _vm._v("Предложений: "),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(record.parsed_info.offers)
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      record.parsed_info.min_price
                                        ? _c("p", [
                                            _vm._v(
                                              "Min цена:\n                                        "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  record.parsed_info.min_price
                                                )
                                              ),
                                            ]),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      record.parsed_info.max_price
                                        ? _c("p", [
                                            _vm._v(
                                              "Max цена:\n                                        "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  record.parsed_info.max_price
                                                )
                                              ),
                                            ]),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("time-ago", {
                                            attrs: {
                                              refresh: "",
                                              long: _vm.long,
                                              tooltip: _vm.tooltip,
                                              datetime:
                                                record.parsed_info.updated_at,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-refresh pointer green m-l-10",
                                            attrs: {
                                              id: `updating_${record.id}`,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateStatistic(
                                                  record.id,
                                                  "offers"
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _c("p", [
                                        _vm._v("Предложений не найдено "),
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-refresh pointer green m-l-10",
                                          attrs: {
                                            id: `updating_${record.id}`,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateStatistic(
                                                record.id
                                              )
                                            },
                                          },
                                        }),
                                      ]),
                                    ],
                              ],
                              2
                            ),
                          ])
                        : _c("div", [
                            _c("div", [
                              _c("p", [
                                _vm._v("Продукт не был найден "),
                                _c("i", {
                                  staticClass:
                                    "icon-fa icon-fa-refresh pointer green m-l-10",
                                  attrs: { id: `updating_${record.id}` },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatistic(record.id)
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: `https://aptekamos.ru/tovary/poisk?q=${record.ros_name}&inr=0`,
                            target: "_blank",
                          },
                        },
                        [_c("i", { staticClass: "icon-fa icon-fa-link" })]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.tableType == "grouped"
                      ? _c("td", [
                          _c(
                            "form",
                            {
                              attrs: { action: "" },
                              on: { submit: _vm.updateWords },
                            },
                            [
                              _c("input", {
                                attrs: { type: "hidden", name: "id" },
                                domProps: { value: record.id },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group" }, [
                                _c(
                                  "textarea",
                                  {
                                    staticClass: "form-control",
                                    attrs: {
                                      required: "",
                                      name: "words",
                                      rows: "3",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.showBtn(record.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.printSearchWords(
                                          record.search_words
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "input-group-prepend" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success hidden",
                                        attrs: {
                                          type: "submit",
                                          id: `wordBtn_${record.id}`,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Сохранить\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.tableType == "grouped"
                      ? _c("td", [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.printSearchWordsStatistic(
                                  record.search_words
                                )
                              ),
                            },
                          }),
                          _vm._v(" "),
                          record.search_words
                            ? _c("div", [
                                record.search_words &&
                                record.search_words[0] &&
                                (record.search_words[0].in_updating == 0 ||
                                  record.search_words[0].in_updating == 2)
                                  ? _c(
                                      "div",
                                      [
                                        _c("time-ago", {
                                          attrs: {
                                            refresh: "",
                                            long: _vm.long,
                                            tooltip: _vm.tooltip,
                                            datetime:
                                              record.search_words[0].updated_at,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "icon-fa icon-fa-refresh pointer green m-l-10",
                                          attrs: {
                                            id: `updating_word_${record.id}`,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateStatistic(
                                                record.id,
                                                "wordstat"
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _vm._v(
                                        "\n                                Обновление\n                            "
                                      ),
                                    ]),
                              ])
                            : _c("div", [
                                _c("span", [_vm._v("Добавьте слова")]),
                              ]),
                        ])
                      : _vm._e(),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }